<template>
    <v-main class="pa-2" fluid>

        
        <v-toolbar flat class="filters">
                        
            <v-btn @click="dialog = true" color="primary" dark>Add new Merch</v-btn>                
                <v-spacer></v-spacer>                        

                <v-text-field
                     v-model="name"
                     append-icon="mdi-magnify"
                     label="Search"
                     
                   ></v-text-field>
                        
                <FilterMerch />
                            
        </v-toolbar>
        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                <!-- <template v-slot:activator="{ on }">
                    
                </template> -->
                <v-card color="lighten-1">
                    <v-toolbar flat>
                        <v-toolbar-title>
                            <span class="headline">New Merch</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-form ref="form" v-model="valid" class="row">
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                    
                                        <v-text-field label="Price" v-model="editedItem.price"  :rules="priceRules" required></v-text-field>

                                <v-select v-model="editedItem.m_l"
                                  :items="m_lOpts"
                                  required
                                  dense
                                  label="M/L/Unisex"
                                  >
                                  </v-select>

                                        <v-select v-model="editedItem.colour"
                                  :items="colours"
                                  required
                                  dense
                                  label="Colour"
                                  >
                                  </v-select>
                                  <v-select v-model="editedItem.size"
                                  :items="sizes"
                                  required
                                  dense
                                  label="Size"
                                  >
                                  </v-select>

                                   <v-text-field label="Quantity" v-model="editedItem.qty"  type="number" required></v-text-field>

                                    </v-col>
                                </v-form>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="filteredMerch"
            :items-per-page="50"
            :search="name"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">

                <v-btn icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>

                <v-btn v-if="item.qty <= 0" icon small color="red" @click="deleteMerch(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn>


                </template>
        </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'
    import FilterMerch from '../components/FilterMerch.vue'

    export default {
        components : { FilterMerch },
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'M/L/Unisex', align: 'start', sortable: true, value: 'm_l', },
                    { text: 'Colour', align: 'start', sortable: true, value: 'colour', },
                    { text: 'Size', align: 'start', sortable: true, value: 'size', },
                    { text: 'Price', align: 'start', sortable: true, value: 'price', },
                    { text: 'Quantity', align: 'start', sortable: true, value: 'qty', },
                    { text: '', align: 'start', sortable: false, value: 'actions', },
                ],
                name : '',
                dialog: false,
                editedIndex: -1,
                editedItem : {
                    name : '',
                    price: 0,
                    m_l : '',
                    colour : '',
                    size : '',
                    qty : 0,
                },
                valid: true,
                lazy: true,
                //isEditing: null,
                
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                priceRules: [
                    v => !!v || 'Price is required',
                ],


                

            }
        },

        mounted () {
            if (this.$store.state.merch.length == 0)
            this.$store.dispatch('fetchMerch')
        },


        computed: {
            ...mapState(['merch']),
            ...mapState(['m_lOpts']),
            ...mapState(['colours']),
            ...mapState(['sizes']),


            filteredMerch() {
                return this.$store.getters.filteredMerch
            },


            formTitle () {
                return this.editedIndex === -1 ? 'New Merch' : 'Edit Merch Item'
            },
        },

        watch: {
            dialog (val) {
            val || this.close()
            }
        },
        
        methods: {

 
            edit(item) { 

                this.editedIndex = this.merch.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/merch/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.merch[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/merch', this.editedItem)
                    .then( response => {

                        this.merch.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              deleteMerch(id) {
                confirm('Are you sure you want to delete this Item? This action can not be undone') && 

                axios.delete('/api/merch/' + id)
                        .then( response => {

                            const index = this.merch.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.merch.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              }
        }
    }
</script>